<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div v-if="show">
    <vue-plotly :data="plotData" :layout="layout" :options="options" class="pa-0 ma-0" />
  </div>
  <div v-else class="align-center">
    <v-img
      class="align-center"
      max-height="100"
      max-width="65"
      src="/reo_pics/error.png"
    ></v-img>
  </div>
</template>

<script>
import VuePlotly from '@statnett/vue-plotly';
import {mapGetters} from 'vuex';
import {config} from '@/store/config';

export default {
  name: 'hist_impexpgraph',
  components: {
    VuePlotly,
  },
  props: [],
  computed: {
    ...mapGetters([
      'get_dsm_result',
      'historyPlotDataTotal',
      'getDsmAppState',
      'app_data',
    ]),

    plotData: function() {
      let plot_list = [
        {
          y: this.array_value_conversion(
            this.historyPlotDataTotal['y'][1],
            'time_weighted',
          ),
          x: this.historyPlotDataTotal['x'],
          //name: "HM_ExportVal",
          name:
            'Total exports of ' +
            this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
              .products.HS6_Code[0] +
            ' -> World',
          mode: 'lines',
          line: {
            color: config.plot_blue,
            width: config.plot_line_width,
            dash: 'solid',
          },
        },

        {
          y: this.array_value_conversion(
            this.$store.getters.historyPlotDataTotal['y'][2],
            'time_weighted',
          ),
          x: this.$store.getters.historyPlotDataTotal['x'],
          //name: "HM_ImportVal",
          name:
            'Total imports of ' +
            this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
              .products.HS6_Code[0] +
            ' <- World',
          mode: 'lines',
          line: {
            color: config.plot_red,
            width: config.plot_line_width,
            //dash:"dot"
          },
        },
      ];

      // Add provincial share if this is a provincial model
      let prov_share = null;
      if (this.$store.state.app.selectedModelName !== 'National') {
        prov_share = {
          y: this.array_value_conversion(
            this.$store.getters.historyPlotDataTotal['y'][1],
            'time_weighted',
          ).map(v => v * this.get_dsm_result['TW_Share_Prov']),
          x: this.$store.getters.historyPlotDataTotal['x'],
          name:
            this.$store.state.app.selectedModelName +
            ' export share' +
            ' (' +
            (this.get_dsm_result['TW_Share_Prov'] * 100).toFixed(2) +
            '%)' +
            ' of ' +
            this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
              .products.HS6_Code[0] +
            ' to World',
          mode: 'lines',
          line: {
            color: config.plot_green,
            width: config.plot_line_width,
            dash: 'dashdot',
          },
        };
        // add the line to the second position (1) and remove 0
        plot_list.splice(2, 0, prov_share);
      }

      return plot_list;
    },
    show: function() {
      return this.$store.getters.historyPlotDataTotal['x'][0] > 1;
    },
    layout: function() {
      return {
        //paper_bgcolor: '#7f7f7f',
        //plot_bgcolor: '#c7c7c7',
        title: {
          //text: "South Africa Total <br> Imports/Exports",
          automargin: true,
          text:
            this.$store.getters.countriesSelectorList.filter(
              c =>
                c['C_Code'] ===
                this.$store.getters.getDsmAppState.dsm_filter_setttings['Home_Market'],
            )[0]['C_Name'] +
            ' - total trade of ' +
            this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
              .products.HS6_Code[0],
          font: {
            size: 10,
            color: 'black',
          },
        },

        height: '300',
        width: '400',
        autosize: true,
        margin: {
          l: 50,
          r: 20,
          b: 80,
          t: 60,
          pad: 2,
        },

        xaxis: {
          fixedrange: true,
          tickmode: 'linear',

          tickfont: {
            size: 10,
          },
          // automargin: true
        },
        yaxis: {
          title: '',
          rangemode: 'tozero',
          fixedrange: true,
          tickfont: {
            size: 10,
          },
           exponentformat:'none'
          // showline: false
        },

        legend: {
          orientation: 'h',
          //dict:{x:1, y:2},
          font: {size: 9},
          automargin: true,
        },
        annotations: [
          {
            x: '0',
            y: '1',
            xref: 'paper',
            yref: 'paper',
            xanchor: 'right',
            yanchor: 'bottom',
            text:
              this.app_data.value_mulitplier['prefix'] +
              ' ' +
              this.app_data.exchange_rate['Currency'].slice(0, 3),
            showarrow: false,
          },
          {
            xref: 'paper',
            yref: 'paper',
            x: 0.39,
            y: this.$store.state.app.selectedModelName !== 'National' ? -0.5 : -0.35,
            xanchor: 'center',
            yanchor: 'top',
            text: config.CEPII_Source,
            showarrow: false,
            font: {
              family: 'Arial',
              size: 8,
              color: 'rgb(150,150,150)',
            },
          },
        ],
      };
    },
  },
  data: function() {
    return {
      options: {
        responsive: true,
        displayModeBar: false,
      },
    };
  },
};
</script>
